import { axInst } from "../../Components/Login/Service";

const handleApiError = (error, apiName) => {
  console.error(`Error in ${apiName}:`, error);
  return null;
};

export const landing_retails = async (body) => {
  try {
    const res = await axInst.post("retails/landing-retails", body);
    return res.data || 0;
  } catch (error) {
    return handleApiError(error, "landing_retails");
  }
};

export const offtake_retails = async (body) => {
  try {
    const res = await axInst.post("retails/offtake-retails", body);
    return res.data || 0;
  } catch (error) {
    return handleApiError(error, "offtake_retails");
  }
};

export const stock_retails = async (body) => {
  try {
    const res = await axInst.post("retails/stock-retails", body);
    return res.data || 0;
  } catch (error) {
    return handleApiError(error, "stock_retails");
  }
};

export const tqp_retails = async (body) => {
  try {
    const res = await axInst.post("retails/tqp-retails", body);
    return res.data || 0;
  } catch (error) {
    return handleApiError(error, "tqp_retails");
  }
};

export const conv_retails = async (body) => {
  try {
    const res = await axInst.post("retails/conv-retails", body);
    return res.data || 0;
  } catch (error) {
    return handleApiError(error, "conv_retails");
  }
};

export const marquee_message = async (body) => {
  try {
    const res = await axInst.post("/marquee_message", body);
    return res.data || 0;
  } catch (error) {
    return handleApiError(error, "marquee_message");
  }
};

export const free_service = async (body) => {
  try {
    const res = await axInst.post("/landing/free_service_hit_rate", body);
    return res.data || 0;
  } catch (error) {
    return handleApiError(error);
  }
};

export const service_penetration = async (body) => {
  try {
    const res = await axInst.post("/landing/service_revenue_penetration", body);
    return res.data || 0;
  } catch (error) {
    return handleApiError(error);
  }
};

export const total_revenue = async (body) => {
  try {
    const res = await axInst.post("/landing/total_revenue", body);
    return res.data || 0;
  } catch (error) {
    return handleApiError(error);
  }
};
